import React, { useEffect, useState, useMemo } from 'react';
import { useFilters, useGlobalFilter, usePagination, useTable } from 'react-table';
import PageTitle from '../../../layouts/PageTitle';
import '../../../../global/filtering.css';
import { v4 as uuid } from 'uuid'
import { Button, Dropdown, Modal } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faCheck, faDotCircle, faEye, faUser } from '@fortawesome/free-solid-svg-icons';
import FormElementsVertical from '../../Forms/FormElementsVerical';
import { UseAPI } from '../../../../services/UseAPI';
import { COLUMNS_DAFTAR_MAHASISWA, COLUMNS_JADWAL } from '../../../../global/Columns';
import { Delete } from '../../../../services/Helper';

function JadwalMahasiswa({jadwalId, ...props}) {
	const [data, setData] = useState([]);
	const columns = useMemo(() => COLUMNS_DAFTAR_MAHASISWA,[]);
	const [showTitle, setShowTitle] = useState(true);
	const [showModalJadwal, setShowModalJadwal] = useState(false);
    console.log("props",props);
    console.log("jadwalId",jadwalId);
    
    
	useEffect(() => {
		const fetchData = async () => {
			UseAPI(`jadwal/${jadwalId}/mahasiswa`,{},'GET').then((resp)=>{
				setData(resp['data'])
			})
		};
		fetchData();
	}, []);


	useEffect(() => {
		if (props.title === 'false') {
			setShowTitle(false);
		}
	}, []);

	const tableInstance = useTable({
		columns,
		data,	
		initialState : {pageIndex : 0}
	}, useFilters, useGlobalFilter, usePagination)

	const { 
		getTableProps, 
		getTableBodyProps, 
		headerGroups, 
		prepareRow,
		state,
		page,
		gotoPage,
		pageCount,
		pageOptions,
		nextPage,
		previousPage,
		canNextPage,
		canPreviousPage,
		setGlobalFilter,
	} = tableInstance


	const {pageIndex} = state  


    const handleInsertJadwalMahasiswa = async(selectedData) => {
        console.log(data);
        UseAPI(`jadwal/${jadwalId}/mahasiswa`, selectedData, 'POST').then((resp) => {
            console.log(resp);
            if (resp.status === 'success') {
                const updatedData = data.map(item => 
                    item.nim === selectedData.nim ? { ...item, scheduled: resp.data.scheduled } : item
                );                
                setData(updatedData);
            }
        });
        
        
    }
	return (
	<>	
		<div className="card">
			<div className="card-body">
				<div className="table-responsive">
					{/* <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} /> */}
					<table {...getTableProps()} className="table display">
						<thead>
						{headerGroups.map(headerGroup => (
								<tr {...headerGroup.getHeaderGroupProps()}>
					                  <th>No.</th>
									{headerGroup.headers.map(column => (
										<th {...column.getHeaderProps()} style={{width:column.width}}>
											{column.render('Header')}
											{column.canFilter ? column.render('Filter') : null}
										</th>
									))}
									<th>Aksi</th>
								</tr>
						))}
						</thead> 
						<tbody {...getTableBodyProps()} className="" >
						
							{page.map((row) => {
								prepareRow(row)
								return(
									<tr {...row.getRowProps()}>
                    					<td>{row.index+1}</td>
										{row.cells.map((cell) => {
											// if (cell.column.Header === 'Terjadwal') {
											// 	return <td key={uuid()} {...cell.getCellProps()}> <FormElementsVertical value={cell.value} type="textarea" readOnly="true" toolBar="false" minHeight="50" /> </td>
											// } else {
                                            // }
                                            return <td key={uuid()} {...cell.getCellProps()}>{cell.render('Cell')}</td>
										})}
										<td>
                                            <Link to='#' onClick={() => handleInsertJadwalMahasiswa(row.original)} > {row.original.scheduled === 'terjadwal' ? <FontAwesomeIcon icon={faCheck} /> : <FontAwesomeIcon icon={faDotCircle} />} </Link>
										</td>
									</tr>
								)
							})}
						</tbody>
					</table> 
					<div className="d-flex justify-content-between">
						<span>
							Page{' '}
							<strong>
								{pageIndex + 1} of {pageOptions.length}
							</strong>{''}
						</span>
						<span className="table-index">
							Go to page : {' '}
							<input type="number" 
								className="ml-2"
								defaultValue={pageIndex + 1} 
								onChange = {e => { 
									const pageNumber = e.target.value ? Number(e.target.value) - 1 : 0 
									gotoPage(pageNumber)
								} } 
							/>
						</span>
					</div>
					<div className="text-center mb-3">	
						<div className="filter-pagination  mt-3">
							<button className=" previous-button" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>{'<<'}</button>
							
							<button className="previous-button" onClick={() => previousPage()} disabled={!canPreviousPage}>
								Previous
							</button>
							<button className="next-button" onClick={() => nextPage()} disabled={!canNextPage}>
								Next
							</button>
							<button className=" next-button" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>{'>>'}</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</>

	);
}

export default JadwalMahasiswa;
